import React, { useState, useEffect } from "react";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";
import {
  Checkbox,
  Select,
  Input,
  MenuItem,
  FormHelperText,
  Grid,
  FormControlLabel,
  makeStyles,
  Typography,
  InputLabel,
} from "@material-ui/core";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

const useStyles = makeStyles((theme) => ({
  textFieldError: {
    color: "#F44336",
  },
  textFieldLabel: {
    color: "var(--txt-f-l-clr)",
    marginBottom: theme.spacing(1),
    fontSize: "13px",
    textAlign: "left",
    fontWeight: 600,
    fontFamily: "Roboto, sans-serif",
  },
}));
export default function LocationPicker({ item, formik }) {
  const classes = useStyles();
  let { values, handleChange, errors, touched } = formik;
  const [country, setCountry] = useState("us");
  const handlePlaceSelected = (place) => {
    let streetAddress = "";

    const addressComponents = place?.address_components || [];
    const state = addressComponents.find((component) =>
      component.types.includes("administrative_area_level_1")
    )?.long_name;
    const city = addressComponents.find(
      (component) =>
        component.types.includes("locality") ||
        component.types.includes("sublocality")
    )?.long_name;
    const zip = addressComponents.find((component) =>
      component.types.includes("postal_code")
    )?.long_name;

    // Use the extracted values as needed
    if (item.getStateAndCity) {
      let dt = { state, city, zip };
      item.getStateAndCity(dt);
    }
    if (item.onlyStreet) {
      const streetNumber = addressComponents.find((component) =>
        component.types.includes("street_number")
      )?.long_name;
      const route = addressComponents.find((component) =>
        component.types.includes("route")
      )?.long_name;
      streetAddress = `${streetNumber || ""} ${route || ""}`;
      formik.setFieldValue(item.name, streetAddress.trim() || "");
      materialRef.current.value = streetAddress;
    } else {
      formik.setFieldValue(item.name, place?.formatted_address || "");
    }
  };

  useEffect(() => {
    if (values[item.name] !== undefined && values[item.name] !== null) {
      formik.setFieldValue(item.name, values[item.name] || "");
      materialRef.current.value = values[item.name];
    }
  }, [values[item.name]]);

  const { ref: materialRef } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    onPlaceSelected: handlePlaceSelected,
    // onPlaceSelected: (place) => handleFileChange(place),
    inputAutocompleteValue: "address",
    options: {
      componentRestrictions: { country },
      strictBounds: true,
      types: ["address"],
    },
  });

  return (
    <>
      <FormControl variant="standard" fullWidth>
        <InputLabel className={classes.textFieldLabel}>{item.label}</InputLabel>
        <TextField
          fullWidth
          variant="standard"
          autoComplete="off"
          inputRef={materialRef}
          InputProps={{
            disableUnderline: true,
            style: {
              fontSize: " 0.95rem",
              fontWeight: 500,
              padding: "0.5rem",
              lineHeight: 1.5,
              color: "var(--txt-f-clr)",
              backgroundColor: item.disabled ? "var(--txt-f-disabled)" : "",
              backgroundClip: "padding-box",
              border: "1px solid #C9D3DD",
              appearance: "none",
              borderRadius: "6px",
              outline: "none",
            },
          }}
        />
      </FormControl>
      {errors[item.name] && touched[item.name] && (
        <FormHelperText className={classes.textFieldError}>
          {errors && errors[item.name]}
        </FormHelperText>
      )}
    </>
  );
}
